module.exports = __webpack_public_path__ + "static/media/logo.9d660725.png";